module.exports = __webpack_public_path__ + "img/upload.e69cf07d.png";